import React from "react";

interface SvgProps {
  className?: string;
}

export const CtaUnderline: React.FC<SvgProps> = ({ className }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 378 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 21.832C84.3608 3.0127 294.451 29.6906 364 15.6609"
        stroke="#FFA686"
        strokeWidth="28"
        strokeLinecap="round"
      />
    </svg>
  );
};